/**
 * Public website facts shared by every marketing page and the build-time
 * pre-render. Schema text is copied exactly from George's website fix list
 * (Part 1, 2 Nov 2026, #6 and #7). If a price changes, change it here too.
 */
export const SITE_ORIGIN = 'https://mydocuploads.com';
export const SITE_NAME = 'MyDocUploads';

/**
 * Public pages with fixed addresses, pre-rendered at build time. Adding one?
 * Also add its hosting rule in deploy/amplify/site-rules.json (a test checks).
 */
export const PUBLIC_ROUTES = [
  '/',
  '/security',
  '/pricing',
  '/blog',
  '/products/core',
  '/products/conversations',
  '/products/secure-drop',
  '/products/sign',
  '/products/flow',
];

/** Default share image until George sends per-page files (fix list #8). */
export const DEFAULT_SHARE_IMAGE = {
  url: `${SITE_ORIGIN}/share/default.jpg`,
  width: 1200,
  height: 630,
  alt: 'MyDocUploads: one secure workspace per client for files, conversations, credentials and signatures',
};

/** Fix list #6: on every public page. */
export const SITE_SCHEMA = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': 'https://mydocuploads.com/#org',
      name: 'MyDocUploads',
      url: 'https://mydocuploads.com/',
      logo: 'https://mydocuploads.com/mydocuploads-logo.png',
      email: 'sales@mydocuploads.com',
      description:
        'Secure document workflow for client-facing firms: one secure workspace per client for files, file conversations, credentials and decisions.',
      parentOrganization: {
        '@type': 'Organization',
        name: 'ConsultraCloud',
        url: 'https://www.consultracloud.com/',
      },
      sameAs: ['https://www.producthunt.com/products/mydocuploads'],
    },
    {
      '@type': 'WebSite',
      '@id': 'https://mydocuploads.com/#site',
      url: 'https://mydocuploads.com/',
      name: 'MyDocUploads',
      publisher: { '@id': 'https://mydocuploads.com/#org' },
    },
  ],
};

/** Fix list #7: on / and /pricing only. */
export const SOFTWARE_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: 'MyDocUploads',
  applicationCategory: 'BusinessApplication',
  operatingSystem: 'Web',
  url: 'https://mydocuploads.com/',
  publisher: { '@id': 'https://mydocuploads.com/#org' },
  description:
    'Every plan includes Core, Conversations, Secure Drop, Sign and Flow. 14-day trial, no credit card required.',
  offers: [
    {
      '@type': 'Offer',
      name: 'Starter',
      price: '29',
      priceCurrency: 'USD',
      url: 'https://mydocuploads.com/pricing',
      description: 'Per month. 1 seat, 50 active workspaces, 100 GB.',
    },
    {
      '@type': 'Offer',
      name: 'Professional',
      price: '99',
      priceCurrency: 'USD',
      url: 'https://mydocuploads.com/pricing',
      description: 'Per month. 5 seats, 250 active workspaces, 1 TB.',
    },
    {
      '@type': 'Offer',
      name: 'Business',
      price: '299',
      priceCurrency: 'USD',
      url: 'https://mydocuploads.com/pricing',
      description: 'Per month. 20 seats, unlimited workspaces, 5 TB.',
    },
  ],
};

/** FAQPage schema built from the same items the page shows (fix list #9). */
export function faqPageSchema(items) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: items.map(({ q, a }) => ({
      '@type': 'Question',
      name: q,
      acceptedAnswer: { '@type': 'Answer', text: a },
    })),
  };
}

/** JSON for a <script type="application/ld+json">, safe inside HTML. */
export function jsonLdText(data) {
  return JSON.stringify(data).replace(/</g, '\\u003c');
}
